import { StorageManager } from 'src/app/common/storage-manager.class';
import { environment } from 'src/environments/environment';

export class FertirrigacionEnvironmentDefinition {
    public rol = StorageManager.getUser().rol;
    
    public appName = environment.appName;
    
    public applicationType = environment.features.applicationType;
    
    public auxServerUrl = environment.serverUrl;
    
    public hasClients = environment.features.hasClients;
    
    public userCanSeeClientes = environment.features.userCanSeeClientes
        ? true
        : this.rol === 'admin';
    
    public hasFincas = environment.features.hasFincas;
    
    public showSectores = environment.features.showSectores;
    
    public fincaName = environment.features.fincaName;
    
    public fincasName = environment.features.fincasName;
    
    public sectorName = environment.features.sectorName;
    
    public sectoresName = environment.features.sectoresName;
    
    public parcelaName = environment.features.parcelaName;
    
    public parcelasName = environment.features.parcelasName;

    public showTareasMto = environment.features.showTareasMto;

    public clienteName = environment.features.clienteName;

    public textoSuperficie = environment.features.textoSuperficie;

    public serverUrl = environment.serverUrl;

    public canAddTareas = environment.features.canAddTareas;

    public showTareasBioExportCsv = environment.features.showTareasBioExportCsv;

    public canDuplicateTareas = environment.features.canDuplicateTareas;
}// class;